import {
  call, put, takeEvery, select,
} from 'redux-saga/effects';
import API from '../../api';
import { AsyncActionStatus } from '../enums';
import { generateErrorMessage } from '../helpers';
import { VersionsActionTypes } from '../actions/types';
import { VersionsActionCreators } from '../actions/creators';
import ChaptersSelectors from '../selectors/chapters.selectors';
import { toast } from '../../utilities';

function* getDataToCompareVersions(action) {
  try {
    const response = yield call(
      API.Versions.getDataToCompareVersions,
      action.payload.projectId,
      action.payload.chapterNumber,
    );
    yield put(
      VersionsActionCreators.getDataToCompareVersions[AsyncActionStatus.FULFILLED](
        response.data.versions,
        response.data.chapters,
        response.data.project,
      ),
    );
  } catch (error) {
    yield put(
      VersionsActionCreators.getDataToCompareVersions[AsyncActionStatus.REJECTED](
        generateErrorMessage(error),
      ),
    );
  }
}

function* addVersion({
  payload: {
    chapterIndex,
    chapter,
    author,
    reason,
    redirectPageUrl,
    allChapters, // TODO: remove this and use instead `chapterId` and `projectId`
    shouldCreate,
    navigate,
  },
}) {
  let shouldCreateVersion = shouldCreate;
  if (!shouldCreateVersion) {
    shouldCreateVersion = yield select(state => state.versions.shouldCreateVersion);
  }

  if (!shouldCreateVersion) {
    yield put(
      VersionsActionCreators.addVersion[AsyncActionStatus.REJECTED](generateErrorMessage(new Error('Request call is rejected as user has made no change to chapter'))),
    );

    if (redirectPageUrl) {
      yield call(navigate, redirectPageUrl);
    }
  } else {
    try {
      let chapters = allChapters;
      if (!chapters?.length) {
        chapters = yield select(ChaptersSelectors.selectAllChapters);
      }
      const chapterId = chapters[chapterIndex]._id;
      const { projectId } = chapters[chapterIndex];
      const version = {
        chapterId,
        projectId,
        delta: chapter.delta,
        author,
        reason,
      };

      const response = yield call(API.Versions.addVersion, version);

      yield put(
        VersionsActionCreators.addVersion[AsyncActionStatus.FULFILLED](response.data.version),
      );

      if (redirectPageUrl) {
        yield call(navigate, redirectPageUrl);
      }
    } catch (error) {
      yield put(
        VersionsActionCreators.addVersion[AsyncActionStatus.REJECTED](generateErrorMessage(error)),
      );
    }
  }
}

function* restoreVersion(action) {
  try {
    const response = yield call(
      API.Versions.restoreVersion,
      action.payload.versionId,
    );
    yield put(
      VersionsActionCreators.restoreVersion[AsyncActionStatus.FULFILLED](response.data.versions),
    );
    yield call(toast.success, t('toastMessages.success.versionRestored', { ns: i18next.Namespace.COMMON }));
    yield call(action.payload.callback);
  } catch (error) {
    yield put(
      VersionsActionCreators.restoreVersion[AsyncActionStatus.REJECTED](
        generateErrorMessage(error),
      ),
    );
  }
}


export default [
  takeEvery(
    VersionsActionTypes.getDataToCompareVersions[AsyncActionStatus.PENDING],
    getDataToCompareVersions,
  ),
  takeEvery(
    VersionsActionTypes.addVersion[AsyncActionStatus.PENDING],
    addVersion,
  ),
  takeEvery(
    VersionsActionTypes.restoreVersion[AsyncActionStatus.PENDING],
    restoreVersion,
  ),
];
